import React from "react";
import { Container } from "reactstrap";
import CardTeam from "../../components/user/CardTeam";
import Footer from "../../components/user/Footer";
import { FaQuoteLeft } from "react-icons/fa";

function About() {
  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          About Us
        </p>
      </div>

      <Container className="py-5">
        <div>
          <p className="fs-5 fw-bold">OUR COMPANY</p>
          <p className="mt-3 t-grey lh-base">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ac
            ligula et mi semper viverra nec a tellus. Curabitur sed diam quis
            elit tempus venenatis sit amet a tellus. Sed id lectus laoreet,
            elementum metus at, sagittis sem. Sed ante velit, eleifend sit amet
            eros lacinia, lobortis vehicula dui. Vivamus fringilla mauris
            mauris. Aliquam lectus ligula, porta a rhoncus sit amet, consequat
            vel nibh. Sed in est venenatis, dictum dui a, consequat quam.
          </p>
          <p className="mt-3 t-grey lh-base">
            Etiam consectetur accumsan odio sit amet sagittis. Aliquam erat
            volutpat. Maecenas eros lacus, commodo id leo ut, ullamcorper varius
            elit. Proin auctor quam convallis, iaculis odio non, iaculis tortor.
            In felis tortor, tristique at magna nec, pharetra posuere leo.
            Praesent ut felis ante. Pellentesque rutrum sed turpis at ornare.
            Nulla tincidunt enim vitae purus rhoncus pellentesque ut ac ligula.
            Vivamus vel gravida nulla, quis aliquam est. Proin ultrices semper
            tortor, at suscipit nibh imperdiet vel. Etiam quis velit viverra
            nisl lobortis imperdiet quis mollis metus. Integer nec felis at
            ligula finibus consequat at ut magna. Duis fermentum dignissim metus
            in pellentesque. Integer viverra iaculis quam vel convallis. Donec
            et leo non velit pharetra placerat. Donec condimentum enim vitae
            felis vulputate, non rhoncus leo fringilla.
          </p>
        </div>

        <div className="my-4 about_note p-4 d-flex">
          <FaQuoteLeft className="me-2 fs-4" />
          <span className="t-grey lh-base">
            I am quote block text, consectetur adipiscing elit. Ut ac ligula et
            mi semper viverra nec a tellus. Curabitur sed diam quis elit tempus
            venenatis sit amet a tellus. Sed id lectus laoreet, elementum metus
            at, sagittis sem. Sed ante velit, eleifend sit amet eros lacinia,
            lobortis vehicula dui. Vivamus fringilla mauris mauris. Aliquam
            lectus ligula porta a rhoncus sit amet consequat vel nibh.
          </span>
        </div>

        <div className="pt-3">
          <p className="fs-5 fw-bold">OUR TEAM</p>
          <p className="mt-3 t-grey lh-base">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ac
            ligula et mi semper viverra nec a tellus. Curabitur sed diam quis
            elit tempus venenatis sit amet a tellus. Sed id lectus laoreet,
            elementum metus at, sagittis sem. Sed ante velit, eleifend sit amet
            eros lacinia, lobortis vehicula dui. Vivamus fringilla mauris
            mauris. Aliquam lectus ligula, porta a rhoncus sit amet, consequat
            vel nibh. Sed in est venenatis, dictum dui a, consequat quam.
          </p>
          <p className="mt-3 t-grey lh-base">
            Etiam consectetur accumsan odio sit amet sagittis. Aliquam erat
            volutpat. Maecenas eros lacus, commodo id leo ut, ullamcorper varius
            elit. Proin auctor quam convallis, iaculis odio non, iaculis tortor.
            In felis tortor, tristique at magna nec, pharetra posuere leo.
            Praesent ut felis ante. Pellentesque rutrum sed turpis at ornare.
            Nulla tincidunt enim vitae purus rhoncus pellentesque ut ac ligula.
            Vivamus vel gravida nulla, quis aliquam est. Proin ultrices semper
            tortor, at suscipit nibh imperdiet vel. Etiam quis velit viverra
            nisl lobortis imperdiet quis mollis metus. Integer nec felis at
            ligula finibus consequat at ut magna. Duis fermentum dignissim metus
            in pellentesque. Integer viverra iaculis quam vel convallis. Donec
            et leo non velit pharetra placerat. Donec condimentum enim vitae
            felis vulputate, non rhoncus leo fringilla.
          </p>
        </div>

        <CardTeam />
      </Container>

      <Footer />
    </div>
  );
}

export default About;
